import {
  Box,
  COLORS,
  Flex,
  Skeleton,
  Text,
  HStack,
  Icon,
  Image,
} from '@podiumhq/design-system';
import locationPin from './locationPin.svg';
import { motion } from 'framer-motion';

const ReviewStar = ({ delay }) => (
  <motion.div
    animate={{ opacity: [0, 1, 1], scale: [0, 1.2, 1] }}
    transition={{ duration: 0.5, delay }}
  >
    <Icon type="StarSolid" color="gold.base" boxSize="32px" />
  </motion.div>
);

const Avatar = ({ profilePhotoUrl }) => {
  return profilePhotoUrl ? (
    <Image src={profilePhotoUrl} h="48px" w="48px" />
  ) : (
    <Box
      background={COLORS.silver.light}
      h="48px"
      w="48px"
      borderRadius="50%"
    />
  );
};

const TimeDescription = ({ relativeTimeDescription }) => {
  return relativeTimeDescription ? (
    <Text fontWeight="normal" fontSize="md">
      {relativeTimeDescription}
    </Text>
  ) : (
    <Skeleton
      mt="8px"
      w="80%"
      h="12px"
      background="#EEECEA"
      isAnimated={false}
      borderRadius="8px"
    />
  );
};

const ReviewCard = ({
  authorName,
  text,
  profilePhotoUrl,
  relativeTimeDescription,
  businessName,
}) => (
  <>
    <Box h="24px" />
    <Flex justifyContent="space-between">
      <Skeleton
        background="#EEECEA"
        w="40%"
        h="8px"
        isAnimated={false}
        borderRadius="8px"
      />
      <Skeleton
        background={COLORS.blue.lighter}
        w="20%"
        h="8px"
        isAnimated={false}
        borderRadius="8px"
      />
    </Flex>
    <Box h="24px" />
    <Flex alignItems="center" w="100%">
      <Image src={locationPin} w="24px" h="24px" />
      <Text
        fontSize="lg"
        fontWeight="medium"
        color={COLORS.grey.lighter}
        overflow="hidden"
        textOverflow="ellipsis"
        whiteSpace="nowrap"
      >
        {businessName}
      </Text>
    </Flex>
    <Box h="16px" />
    <Flex alignItems="center">
      <Avatar profilePhotoUrl={profilePhotoUrl} />
      <Box ml="16px">
        <Text fontSize="lg" fontWeight="medium">
          {authorName}
        </Text>
        <TimeDescription relativeTimeDescription={relativeTimeDescription} />
      </Box>
    </Flex>
    <Box h="24px" />
    <HStack spacing="8px">
      <ReviewStar delay={0.7} />
      <ReviewStar delay={0.9} />
      <ReviewStar delay={1.1} />
      <ReviewStar delay={1.3} />
      <ReviewStar delay={1.5} />
    </HStack>
    <Box h="24px" />
    <Box position="relative" h="258px" overflow="hidden">
      <Text fontSize="md" lineHeight="150%">
        {text}
      </Text>
      <Box
        position="absolute"
        bottom="0"
        left="0"
        width="100%"
        height="40px"
        background="linear-gradient(180deg, rgba(255,255,255,0), rgba(255,255,255,1))"
      ></Box>
    </Box>
  </>
);

export default ReviewCard;
